// export const useDisabledAdv = () => {
//   var storedValue = useCook("useDisabledAdv",{maxAge: 60 * 60 * 24 * 31 * 6}).value
//   var data = ref(storedValue ? true : false);

//   watch(data, (newValue) => {
//     console.log('set cookie useDisabledAdv', newValue);
//     useCook("useDisabledAdv",{maxAge: 60 * 60 * 24 * 31 * 6}).value = newValue;
//   });
//   return data;
// }

export const useDisabledAdv = () => {
  const cookie = useCook<boolean>('useDisabledAdv', {
    maxAge: 60 * 60 * 24 * 31 * 6,
    watch: 'shallow'
  })
  return cookie
}

// export const useExperimentsDiaryWide = () => {
//   var storedValue = useCook("useExperimentsDiaryWide",{maxAge: 60 * 60 * 24 * 31 * 6}).value
//   var data = ref(storedValue ? true : false);

//   watch(data, (newValue) => {
//     console.log('set cookie useExperimentsDiaryWide', newValue);
//     useCook("useExperimentsDiaryWide",{maxAge: 60 * 60 * 24 * 31 * 6}).value = newValue;
//   });

//   return data;
// }

export const useExperimentsDiaryWide = () => {
  const cookie = useCook<boolean>('useExperimentsDiaryWide', {
    maxAge: 60 * 60 * 24 * 31 * 6,
    watch: 'shallow'
  })
  return cookie
}


// export const useTranslateLinks = () => {
//   var storedValue = useCook("useTranslateLinks",{maxAge: 60 * 60 * 24 * 31 * 6, watch: 'shallow'}).value
//   var data = ref(storedValue ? true : false);

//   watch(data, (newValue) => {
//     console.log('set cookie useTranslateLinks', newValue);
//     useCook("useTranslateLinks",{maxAge: 60 * 60 * 24 * 31 * 6}).value = newValue;
//   });

//   return data;
// }

export const useTranslateLinks = () => {
  const cookie = useCook<boolean>('useTranslateLinks', {
    maxAge: 60 * 60 * 24 * 31 * 6,
    watch: 'shallow'
  })
  return cookie
}

// export const useExperimentsRegion = () => {
//   var storedValue = useCook("useExperimentsRegion",{maxAge: 60 * 60 * 24 * 31 * 6, watch: 'shallow'}).value
//   var data = ref(storedValue ? storedValue : 'auto');

//   watch(data, (newValue) => {
//     useCook("useExperimentsRegion",{maxAge: 60 * 60 * 24 * 31 * 6}).value = newValue;
//   });

//   return data;
// }

export const useExperimentsRegion = () => {
  const cookie = useCook<string>('useExperimentsRegion', {
    maxAge: 60 * 60 * 24 * 31 * 6,
    watch: 'shallow'
  })
  return cookie
}

export const usePageBottomMargin = () => useState('usePageBottomMargin', () => 0)



export const useDiaryWeeksOrder = () => {

  const state = useState<string>('ui:weeks-order', () => {
    const cookieVal = useCook<string>('ui:weeks-order').value
    return cookieVal ?? 'desc'
  })
  const cookieRef = useCook<string>('ui:weeks-order')
  watch(state, (val) => {
    cookieRef.value = val
  })

  return state
}



